import { requestableCategoryRepository } from '@webapp/modules/expense/data-access/repositories/RequestableCategoryRepository'
import { ResolveReviseFormDefaultsUseCase } from './ResolveReviseFormDefaults'

export const resolveReviseFormDefaultsUseCase =
  new ResolveReviseFormDefaultsUseCase({
    requestableCategoryRepository,
  })

export { ResolveReviseFormDefaultsUseCase } from './ResolveReviseFormDefaults'
